import React from "react";
import { connect } from "react-redux";
import ReactEcharts from "echarts-for-react";
import {incomeExpenseChartOption} from "../../Data/Charts";
import "echarts-gl";
class IncomeExpenseDataChart extends React.Component {
  componentDidMount() {

  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.incomeExpenseChartData !== this.props.incomeExpenseChartData) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const { incomeExpenseChartData } = this.props;
    return incomeExpenseChartData;
  }
  render() {
    const optionPieEchart = this.chartPlace()
    const option = incomeExpenseChartOption(optionPieEchart);

    return (
       <ReactEcharts option={option}>
         opts={{ renderer: 'svg' }}
         style={{ height: '400px', width: '100%' }}
       </ReactEcharts>

    );
  }
}

const mapStateToProps = (state) => ({
  incomeExpenseChartData: state.analyticalReducer.incomeExpenseChartData
});

export default connect(mapStateToProps, {})(IncomeExpenseDataChart);
